export enum PatientAttachmentAttachmentSource {
  inboundFax = 'inbound_fax',
  ehr = 'ehr',
  outreachAttempt = 'outreach_attempt',
  hie = 'hie',
}
